<template>
  <div class="dizme_tm_mobile_menu">
    <div class="mobile_menu_inner">
      <div class="mobile_in">
        <div class="logo">
          <a href="#"
            ><img :src="`img/logo/${dark ? 'dark' : 'logo'}.png`" alt="ქორწილის ვიდეოგრაფი ზუგდიდში"
          /></a>
        </div>
        <div class="trigger" @click="activeToggle()">
          <div
            class="hamburger hamburger--slider"
            :class="active ? 'is-active' : ''"
          >
            <div class="hamburger-box">
              <div class="hamburger-inner"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown" :style="{ display: active ? 'block' : 'none' }">
      <div class="dropdown_inner">
        <ul class="anchor_nav">
          <li class="current"><a href="#მთავარი">მთავარი</a></li>
          <li><a href="#ჩემს_შესახებ">ჩემს შესახებ</a></li>
          <li><a href="#პორტფოლიო">პორტფოლიო</a></li>
          <li><a href="#მომსახურება">მომსახურება</a></li>
          <li><a href="#ბლოგი">ბლოგი</a></li>
          <li><a href="#კონტაქტი">კონტაქტი</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileHeader",
  data() {
    return {
      active: false,
    };
  },
  methods: {
    activeToggle() {
      this.active = !this.active;
    },
  },
  props: {
    dark: { type: Boolean },
  },
};
</script>
